import * as Api from '@ViewModels';
import { useHistory } from 'react-router';
import { toast } from 'sonner';
import {
	invalidateIntegrationStatusQuery,
	useCallbackAuthorizeUrlMutation,
	useDisableIntegrationMutation,
	useIntegrationStatusQuery,
} from '../../../../queries';
import { IntegrationOAuthStep } from '../../../../viewmodels/AppViewModels';

export const getOAuthStepFromIntegrationStatus = (status: Api.IIntegrationStatus) => {
	if (!status.isConnected) {
		return IntegrationOAuthStep.SignIn;
	}
	return status.lastLoadDate ? IntegrationOAuthStep.Connected : IntegrationOAuthStep.InProgress;
};

export function useManageIntegrationConnection({ provider }: { provider: Api.ConfigurableIntegrationType }) {
	const history = useHistory();
	const disableIntegrationMutation = useDisableIntegrationMutation({
		onError: error => {
			toast.error(error.systemMessage);
		},
		onSuccess: () => {
			toast.success('Integration disabled successfully');
			invalidateIntegrationStatusQuery(provider);
			history.push('/integrations');
		},
	});
	const callbackAuthorizeUrlMutation = useCallbackAuthorizeUrlMutation({
		onError: error => {
			toast.error(error.systemMessage);
		},
		onSuccess: url => {
			window.location.replace(url);
		},
	});
	const integrationStatusQuery = useIntegrationStatusQuery({ provider });
	const oauthStep: IntegrationOAuthStep | null = integrationStatusQuery.data
		? getOAuthStepFromIntegrationStatus(integrationStatusQuery.data)
		: null;
	const onConnect = () => {
		callbackAuthorizeUrlMutation.mutate({ provider });
	};
	const onDisable = () => {
		disableIntegrationMutation.mutate(provider);
	};
	return {
		oauthStep,
		onConnect,
		onDisable,
		isLoadingCallbackAuthUrl: callbackAuthorizeUrlMutation.isPending,
		hasIntegrationStatusLoaded: integrationStatusQuery.isSuccess,
	};
}
